import React from 'react';
import Login from './Login';
import Navigator from './Navigator';
import { useAuth } from '../context/AuthContext';

export default function Home() {
  const { userInfo } = useAuth();
  console.log("userInfo da Home ", userInfo)
    return (
    <div style={{height: "100%"}}>
      {userInfo == null
        ? <Login/>
        : <Navigator/>}
    </div>
  );
}